import { render, staticRenderFns } from "./RankingPncCollaboration.vue?vue&type=template&id=5935015a&scoped=true"
import script from "./RankingPncCollaboration.vue?vue&type=script&lang=js"
export * from "./RankingPncCollaboration.vue?vue&type=script&lang=js"
import style0 from "./RankingPncCollaboration.vue?vue&type=style&index=0&id=5935015a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935015a",
  null
  
)

export default component.exports